import { render, staticRenderFns } from "./ResearchProgress.vue?vue&type=template&id=155be49c&scoped=true&"
import script from "./ResearchProgress.vue?vue&type=script&lang=js&"
export * from "./ResearchProgress.vue?vue&type=script&lang=js&"
import style0 from "./ResearchProgress.vue?vue&type=style&index=0&id=155be49c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "155be49c",
  null
  
)

export default component.exports